import React from 'react';

import PreviewHeader from './PreviewHeader';
import Preview from './Preview';

import classes from './styles.module.scss';

export default function RightPanel({
  fonts,
  colors,
  logoSettings,
  contacts,
  tenantSettings,
  refetchTenantSettings,
  activeTab,
}) {
  return (
    <div className={classes.RightPanel}>
      <PreviewHeader
        fonts={fonts}
        colors={colors}
        logoSettings={logoSettings}
        contacts={contacts}
        tenantSettings={tenantSettings}
        refetchTenantSettings={refetchTenantSettings}
      />
      <Preview
        brandColors={colors}
        logoSettings={logoSettings}
        fonts={fonts}
        activeTab={activeTab}
      />
    </div>
  );
}
